import { roadsAndWaterProjects } from './roadsAndWater';
import { miningBuildingsMaintenanceProjects } from './miningBuildingsMaintenance';
import type { Project, ProjectCategory } from '../../types/content';

export const projectCategories: ProjectCategory[] = [
  { id: 'all', label: 'All Projects' },
  { id: 'roads', label: 'Roads & Transport' },
  { id: 'mining', label: 'Mining & Earthworks' },
  { id: 'water', label: 'Water & Sanitation' },
  { id: 'buildings', label: 'Buildings & Structures' },
  { id: 'maintenance', label: 'Maintenance & Rehabilitation' },
];

/** Only records approved for publication appear on the website. */
export const projects: Project[] = [...roadsAndWaterProjects, ...miningBuildingsMaintenanceProjects].filter(
  (project) => project.publication === 'published',
);

export const featuredProjects = projects.filter((project) => project.featured);

export function getProjectById(id: string) {
  return projects.find((project) => project.id === id);
}
